import UIPanelSection from 'UIComponents/panel/UIPanelSection';
import UIOptimisticNanoProgress from 'UIComponents/progress/UIOptimisticNanoProgress';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { useGetActionOutputsForTargetActionById } from 'automation-ui-action-features/action-outputs/actionOutputHooks';
import { useAllExtensionDefinitions } from 'automation-ui-action-features/actions/extension/extensionQueries';
import { AUTOMATION_EXTENSION } from 'automation-ui-action-features/constants/ActionTypes';
import EnrollmentHistoryPageLogEventDetails from 'automation-ui-canvas/containers/enrollment-history/panel/selected-enrollment/EnrollmentHistoryPageLogEventDetails';
import HistoryEnrollmentLogEventHeader from 'automation-ui-log-events/components/HistoryEnrollmentLogEventHeader';
import { getActionType, getIdempotencyId, getType } from 'automation-ui-log-events/records/LogEvent/utils';
import { WORKFLOWS_APP } from 'automation-ui-source-apps/constants/SourceApps';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import { Map as ImmutableMap } from 'immutable';
import { useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import UserInputPrompt from 'automation-ui-canvas/containers/enrollment-history/panel/selected-enrollment/UserInputPrompt';
import { ExpandableSection } from 'foundations-components/transitional/components/ExpandableSection';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SelectedEnrollmentLogEventsSection = ({
  logEvents,
  currentVersionFlow,
  polling,
  setPolling,
  userInputEvent
}) => {
  var _extensionsData$allEx;
  const history = useHistory();
  const trackEvent = useTrackEvent();
  const {
    search,
    pathname
  } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const [expandedLogEvents, setExpandedLogEvents] = useState(ImmutableMap());
  const activeLogEventKey = searchParams.get('logEventKey');
  const uniqueExtensionActionTypeIds = currentVersionFlow ? [...new Set(Object.values(currentVersionFlow.actions).filter(actionInFlow => actionInFlow.actionType === AUTOMATION_EXTENSION).map(actionInFlow => actionInFlow.actionTypeId))] : [];
  const {
    data: extensionsData,
    loading
  } = useAllExtensionDefinitions({
    objectType: currentVersionFlow.objectTypeId,
    createdSourceApp: WORKFLOWS_APP,
    actionTypeIdsToInclude: uniqueExtensionActionTypeIds
  });
  const extensionDefinitions = (_extensionsData$allEx = extensionsData === null || extensionsData === void 0 ? void 0 : extensionsData.allExtensionDefinitions) !== null && _extensionsData$allEx !== void 0 ? _extensionsData$allEx : {};
  useEffect(() => {
    let currentExpandedLogEvents = expandedLogEvents;
    if (activeLogEventKey) {
      currentExpandedLogEvents = currentExpandedLogEvents.clear();
      currentExpandedLogEvents = currentExpandedLogEvents.set(activeLogEventKey, true);
    }
    setExpandedLogEvents(currentExpandedLogEvents);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeLogEventKey]);
  const getActionOutputsForTargetActionById = useGetActionOutputsForTargetActionById(currentVersionFlow);
  const handleExpandSection = logEvent => {
    const currentKey = getIdempotencyId(logEvent);
    const isExpanded = expandedLogEvents.get(currentKey);
    if (searchParams.get('logEventKey')) {
      searchParams.delete('logEventKey');
      history.replace({
        pathname,
        search: searchParams.toString()
      });
    }
    trackEvent(Trackables.PERFORMANCE_HISTORY_TOGGLE_LOGEVENT_SECTION, {
      toggleType: isExpanded ? 'Collapse' : 'Expand',
      logEventType: getType(logEvent),
      actionType: getActionType(logEvent)
    });
    setExpandedLogEvents(expandedLogEvents.set(currentKey, !isExpanded));
  };
  const scrollTo = activeElement => {
    return activeElement && activeElement.scrollIntoView({
      block: 'center'
    });
  };
  if (loading) {
    return /*#__PURE__*/_jsx(UIOptimisticNanoProgress, {
      value: 10
    });
  }
  return /*#__PURE__*/_jsxs(UIPanelSection, {
    className: "p-all-0",
    children: [logEvents.map(logEvent => {
      const logEventKey = getIdempotencyId(logEvent);
      const isUserInputEvent = logEvent === userInputEvent;
      const isOpen = logEventKey && expandedLogEvents.get(logEventKey) || isUserInputEvent;
      return /*#__PURE__*/_jsx(View, {
        as: "div",
        ref: logEventKey === activeLogEventKey ? scrollTo : null,
        backgroundColor: isOpen ? 'fill-surface-raised' : 'fill-surface-default',
        children: /*#__PURE__*/_jsx(ExpandableSection, {
          titleText: /*#__PURE__*/_jsx(HistoryEnrollmentLogEventHeader, {
            flowObjectTypeId: currentVersionFlow.objectTypeId,
            logEvent: logEvent,
            shouldTruncate: true
          }),
          onOpenChange: () => handleExpandSection(logEvent),
          open: isOpen,
          children: isUserInputEvent ? /*#__PURE__*/_jsx(UserInputPrompt, {
            logEvent: logEvent,
            onSubmit: () => setPolling(true)
          }) : /*#__PURE__*/_jsx(EnrollmentHistoryPageLogEventDetails, {
            logEvent: logEvent,
            flow: currentVersionFlow,
            flowObjectTypeId: currentVersionFlow.objectTypeId,
            extensionDefinitions: extensionDefinitions,
            getActionOutputsForTargetActionById: getActionOutputsForTargetActionById,
            flowLastUpdatedAt: currentVersionFlow.updateMetadata.updatedAt
          })
        })
      }, logEventKey);
    }), polling && /*#__PURE__*/_jsx(UILoadingSpinner, {
      className: "m-y-4",
      grow: true
    })]
  });
};
export default SelectedEnrollmentLogEventsSection;